module.exports = __webpack_public_path__ + "media/1x1/mc-78528abe.svg";